export default {
    s3AccessKeyId: 'U2FsdGVkX1/bMz5FuvEZhQgqdziNrj+lVOFnJ6MnCHzrW51eMEczl5qdQDYu/l9Y', //AKIAXQ5D7SLFKHDZUONZ
    s3SecretAccessKey: 'U2FsdGVkX19Zk7mJuGY8sKD1hfLoi1ZsiTbzNt5HxGi+giJWxpgikd1A2XAiWl8iGwur3xyviRBIGHGaO3KcsQ=='
  }